import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { authService } from '../../services/authService';

export const useGetEmailOtpStatus = (email, options = {}) => {
  const { onTokenExpired, enabled = Boolean(email), ...queryOptions } = options;

  return useQuery({
    queryKey: [QUERY_KEYS.auth.email_otp_status, email],
    enabled,
    queryFn: () =>
      authService.emailOtpStatus().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        if (status === 401) {
          onTokenExpired && onTokenExpired();
        }
        throw new Error('Fetch failed');
      }),
    ...queryOptions,
  });
};
